import { takeLatest, put, call } from 'redux-saga/effects';
import { axiosInstance } from '../../utils';
import { changeBookingStatus } from "../actions";

import { VALIDATION_REQUEST, VALIDATION_SUCCESS, VALIDATION_FAILURE } from "../types";

function* ticketSaga({ payload }) {
  const { code, bookingId } = payload;

  try {
    yield call(axiosInstance.post, `booking/${bookingId}/validate`, { pincode: code });
    yield put(changeBookingStatus(2));
    yield put({ type: VALIDATION_SUCCESS });
  } catch (error) {
    yield put({ type: VALIDATION_FAILURE, payload: error.error });
  }
}

export default function* saga() {
  yield takeLatest(VALIDATION_REQUEST, ticketSaga);
}
